import type { PartnerBankAccountResponseDto } from "Infrastructure/Api/Api";
import { Resources, useResource } from "Infrastructure/Translation/Resources";
import { BankAccountForm } from "Partner/Components/Form/BankAccountForm";
import { BaseCard } from "Shared/Components/Cards/BaseCard";

const bankAccountResources = Resources.base.partner.detail.bankAccount;

type PartnerBankAccountFormWidgetProps = {
	partnerId: number;
	data?: PartnerBankAccountResponseDto[];
};

export function PartnerBankAccountFormWidget({
	partnerId,
	data,
}: PartnerBankAccountFormWidgetProps) {
	const { t } = useResource();

	return (
		<BaseCard title={t(bankAccountResources.title)}>
			<BankAccountForm
				partnerId={partnerId}
				partnerBankAccountData={data ?? []}
			/>
		</BaseCard>
	);
}
